import { translateFn } from '../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { MaxLengthValidator } from '../../../../../../../ui/gzForm/validators/max-length.validator';
import { IpValidator } from '../../../../../../../ui/gzForm/validators/ip.validator';
import { FirewallExclusionItem } from '@nirvana/shared/dtos/types/policies/common';

const DESCRIPTION_MAX_LENGTH = 64;

// get validators for ip field
export const ipValidators = (): FormValidator<string>[] => {
  return [
    RequiredValidator(translateFn('Required field')),
    IpValidator(translateFn('Invalid IP/mask format'), true, true),
  ];
};

// get validators for description field
export const descriptionValidators = (): FormValidator<string>[] => {
  return [
    MaxLengthValidator(
      DESCRIPTION_MAX_LENGTH,
      translateFn('The description must have a maximum of {maxLength} characters.', {
        maxLength: DESCRIPTION_MAX_LENGTH,
      })
    ),
  ];
};

// validate duplicates
export function validateDuplicates(
  item: FirewallExclusionItem,
  itemsInGrid: FirewallExclusionItem[]
): ValidationResult {
  const hasDuplicates = itemsInGrid.some((itemInGrid: FirewallExclusionItem) => itemInGrid.ip === item.ip);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
